import React, {useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import {Box, Card, CardContent, Chip, Link, Stack} from '@mui/material';
import { useErrorBoundary } from 'react-error-boundary';
import { TrendingTopic } from '../../../types/search/trendingTopics';

const SearchTrending = (): JSX.Element => {
  
  useEffect(() => {
    getTrendingTopics();
  },[])
  
  const { showBoundary } = useErrorBoundary();      
  const [topSearches, setTopSearches] = useState<TrendingTopic[]>();

  const getTrendingTopics = async () => {
    try{
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/public/search/trending`)
        .then(result => {
          if (!result.ok) {
            showBoundary(new Error('Failed to get the trending topics.'));
          }
          return result.json();
        })
        .then(result => {
          let count = result.length;
          if (count > 0){
             setTopSearches(result);
          }
        });
    }catch(error){
      console.error('Uncaught Error:', error);
      showBoundary(new Error(`${error}`));
    }
  }

        return (
            <Box marginTop={2}>
                <Card sx={{ boxShadow: 1}}>
                    <CardContent>
                    <Box marginTop={1}>
                        <Typography paddingLeft={2} variant='subtitle1' fontWeight={550} >Trending Topics</Typography>
                    </Box>
                    <Box padding={2}>
                      <Stack 
                        direction="row" 
                        spacing={1}  
                        alignItems={'flex-start'}
                        useFlexGap
                        flexWrap="wrap">
                        {
                          topSearches?.map((search) => (
                            <Chip sx={{cursor: 'pointer'}} component={Link} href={`/search?q=${search.description}`} label={search.description} key={search.id} variant="outlined"></Chip>
                          ))
                        }
                      </Stack>
                      </Box>
                    </CardContent>
                </Card>
              </Box>
        );
};

export default SearchTrending;